module.exports = __webpack_public_path__ + "img/hotsale.jpg";